import { ServiceQuestionType } from '../api/create-question';

export const QUESTION_TYPE_LABELS: {
  [key in ServiceQuestionType]: string;
} = {
  open: 'Ouverte',
  single_choice: 'Choix unique',
  multiple_choice: 'Choix multiple',
};

export const QUESTION_TYPE_VALUES: ServiceQuestionType[] = [
  'open',
  'single_choice',
  'multiple_choice',
];
